import request  from '@/utils/request';

//直接发起
export function directInitiation(data) {
    return request({
        url: '/api/direct_faqi_putong',
        method: 'post',
        data
    })
}
//直接发起 支付模式
export function directInitiation_pay(data) {
    return request({
        url: '/api/direct_faqi_pay',
        method: 'post',
        data
    })
}